exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".collection-video-header .content-top[data-v-24e78b89]{height:25vh}@media (min-width:992px){.collection-video-header .content-top[data-v-24e78b89]{height:40vh}}.collection-video-header .bg-video[data-v-24e78b89]{margin-top:-3.125rem}", ""]);

